<template>
    <div>
        <h1>Liste des clients</h1>
        <div id="clientTab" class="pl-list">
            <div class="header">
                <div class="header_line">
                    <div id="header_col1" class="header_col col1">Nom</div>
                    <div id="header_col4" class="header_col col4">Code client</div>
                    <div id="header_col4" class="header_col col4">Nbre Experts</div>
                    <div id="header_col4" class="header_col col4">Nbre Domaines</div>
                    <div id="header_col5" class="header_col col5">Nbre Configuratons</div>
                </div>
            </div>
        
            <div class="content">

                <clientLine v-for="(client) in clients" :key='client.id' :clientObj='client'   ></clientLine>
            
            </div>
            <div class="footer">
                <div class="buttons">
                    <button id="btn_add" type="button" class="liste_btn boutonTableau" title="Créer" @click='clickBtnAdd()'>Créer</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FctUtils from '@/components/FctUtils';
    import ClientLine from '@/components/ClientLine';
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig } from "../constantes";

    export default {
        name:"Clients",
        components:{
            "clientLine":ClientLine,
        },
        mixins: [FctUtils],
        data(){
            return {
                clients:{}
            }
        },
        mounted() {
            this.emitter.on('createClient', newClientData => {
                this.createClient(newClientData)
            });
            this.emitter.on('editClient', newClientData => {
                this.editClient(newClientData)
            });
            this.emitter.on('removeClient', newClientData => {
                this.removeClient(newClientData)
            });
        },
        unmounted() {
            this.emitter.off('createClient');
            this.emitter.off('removeClient');
        },
        created() {        
            axios.get(diagonalbackURL + "/clients", defaultConfig)
            .then(reponse => {
                var tmpClient = reponse.data;
                tmpClient.sort(function(a,b) {return a.name.localeCompare(b.name)})
                this.clients = tmpClient;

                // Pour ne pas surcharger le serveur de requêtes, on lance les requêtes de chargement d'informations complémentaires
                // en synchrone les unes après les autres.
                //
                (async () => {
                    let response;

                    for (var i = 0; i < this.clients.length; i++) {
                        try {
                            response = await axios(diagonalbackURL + "/clients/"+ this.clients[i].id +"/summary", defaultConfig);
                            this.clients[i] = response.data;
                        }
                        catch(error) {
                            this.errorHandler(error)
                        }
                    }
                })();
            })
            .catch(error => this.errorHandler(error));
        },
        methods : {
            
            clickBtnAdd() {
                this.emitter.emit('showPLForm', {mode: 'formClient_new'});
            },
            // Création d'un client.
            //
            createClient(newClientData) {
                console.log("Creation du client : "+newClientData.name)

                const params = JSON.stringify({
                    'name':newClientData.name,
                    'code':newClientData.code
                });

                axios.put(diagonalbackURL + "/clients", params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));

            },
            // Modification d'un client.
            //
            editClient(aClientData) {
                console.log("Modification d'un client : " + aClientData.name)

                const params = JSON.stringify({
                    'name':aClientData.name,
                    'code':aClientData.code
                });

                axios.post(diagonalbackURL + "/clients/"+aClientData.id, params, defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));
            },
            // Suppression d'un client.
            //
            removeClient(toDelClient) {
                console.log("Suppression du client : "+toDelClient.name)

                axios.delete(diagonalbackURL + "/clients/"+toDelClient.id,  defaultConfig)
                .then(reponse => {
                    this.$router.go();
                })
                .catch(error => this.errorHandler(error));

            },
        }       
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/* Client Page */

.header_line {
    overflow:hidden;
}

#clientTab.pl-list .content {
    max-height: 500px;
}

</style>
